import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=779b125a&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('779b125a')) {
      api.createRecord('779b125a', component.options)
    } else {
      api.reload('779b125a', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=779b125a&", function () {
      api.rerender('779b125a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Cm6A52qOq9HJ/JS/comp/FavElement.vue"
export default component.exports